import { render, staticRenderFns } from "./leave-summary.vue?vue&type=template&id=1a8f5081&"
import script from "./leave-summary.vue?vue&type=script&lang=js&"
export * from "./leave-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports